import React,{useState} from 'react'
import './verifyEmailOTP.css'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function VerifyEmailOTP() {
  const [otp, setOtp] = useState('');
const navigate = useNavigate();
  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleVerifyClick = async (e) => {
    e.preventDefault();
    // Add verification logic here
    try{
        const res = await axios.post(`${process.env.REACT_APP_URL}/api/verify-email`, { email: localStorage.getItem("userEmail"), otp });
        if(res.data.success){
            alert("Email verified successfully!");
            navigate('/'); // You can redirect the user to the dashboard or home page here
            // You can redirect the user to the dashboard or home page here
        }
    } catch (error) {
        console.error('Error verifying OTP:', error);
    }
  };

  return (
    <>
        <h1>Verify Your Email</h1>
        <p>OTP has been sent to your email</p>

        <form action="#" onSubmit={handleVerifyClick} method="post">
            <label htmlFor="otp">Enter OTP:</label>
            <input type="text" id="otp" name="otp" onChange={handleOtpChange} required />
            <button type="submit">Verify</button>
        </form>
    </>
  )
}